/* global yaCounter85056037 */
import helpers from '../helpers';

function start15SecTimeout() {
	clearTimeout(helpers.$window.data('timeout15Sec'));

	helpers.$window.data('timeout15Sec', setTimeout(() => {
		ga('rbcspec.send', 'event', 'page', 'spent_on_page_15_sec');
		ga('send', 'event', 'page', 'spent_on_page_15_sec');
	}, 15000));
}

function progress(per) {
	ga('send', 'event', 'Scroll Depth', 'Percentage', `${per}%`, {nonInteraction: false});
	ga('rbcspec.send', 'event', 'Scroll Depth', 'Percentage', `${per}%`, {nonInteraction: false});
}

jQuery.scrollDepth({
	userTiming: false,
	pixelDepth: false,
	gtmOverride: true,
	eventHandler(data) {
		ga('send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
		ga('rbcspec.send', 'event', data.eventCategory, data.eventAction, data.eventLabel, {nonInteraction: false});
	},
});

/**
* Создать куки запись
* @param {string} path Обязательное, ссылка/путь
*/
function virtualHit(path) {
	if (window.ga) {
		ga('set', 'page', path);
		ga('send', 'pageview', path);

		// Не всегда используются
		ga('rbcspec.set', 'page', path);
		ga('rbcspec.send', 'pageview', path);
	}

	// NUMBERID нужно менять для каждого проекта, так же используется в PUG
	if (window.yaCounter85056037) {
		yaCounter85056037.hit(path);
	}
}

/**
 * Click on objects
 */

// Client logo
$(document).on('click', '.header__logo-link--real--js', () => {
	ga('send', 'event', 'client link', 'logo header');
	ga('rbcspec.send', 'event', 'client link', 'click');
});

// Rbc logo
$(document).on('click', '.header__logo-link--rbc--js', () => {
	ga('send', 'event', 'nav', 'rbc logo');
});

// Nav
// $(document).on('click', '.menu__link--js', () => {
// 	ga('send', 'event', 'nav', 'rbc topline link');
// });

// Anchor arrow
$(document).on('click', '.header__arrow-btn-desktop--js, .header__arrow-btn-mobile--js', () => {
	ga('send', 'event', 'main', 'down button click');
});

// Get article title
function getTitle(event) {
	return $(event.target).parents('.article').find('.article__title').text();
}

// Anons articles
$(document).on('click', '.article:not(.article--sm) .article__strech-link', (event) => {
	const title = getTitle(event);
	ga('send', 'event', 'main', 'material click', title);
});

// Five reasons...
$(document).on('click', '.header__five-reasons-link', () => {
	ga('send', 'event', 'main', 'material click', '5 причин инвестировать в Ивановскую область');
});

// Anons related articles
$(document).on('click', '.article--sm .article__strech-link', (event) => {
	const title = getTitle(event);
	ga('send', 'event', 'article', 'see also bottom', title);
});

// Social share article
$(document).on('click', '.social--icons .social__item-link--js', (event) => {
	ga('send', 'event', 'share', 'article share', event.target.dataset.social);
});

// Social share project
$(document).on('click', '.social:not(.social--icons) .social__item-link--js', (event) => {
	ga('send', 'event', 'share', 'project share', event.target.dataset.social);
});

export default {
	start15SecTimeout,
	virtualHit,
	progress,
};
